import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MapDataFieldComponent } from 'src/app/map-data/map-data-field/map-data-field.component';
import dayjs from "dayjs";


@Component({
    selector: 'app-download-satellite-report',
    templateUrl: './download-satellite-report.component.html',
    styleUrls: ['./download-satellite-report.component.css'],
    standalone: false
})
export class DownloadSatelliteReportComponent implements OnInit{

  filterForm: FormGroup;

  startDate = null;
  endDate = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MapDataFieldComponent>) { 

      this.filterForm = this.fb.group({
        filterStartDate: new FormControl(null),
        filterEndDate: new FormControl(null)
    });

    }

  ngOnInit(): void {

    this.startDate = dayjs().subtract(30, 'day').toDate().toISOString();
    this.endDate = dayjs().toDate().toISOString();

    setTimeout(()=>{
      this.filterForm.controls.filterStartDate.setValue(this.startDate);
      this.filterForm.controls.filterEndDate.setValue(this.endDate);
    },500)
  }

  setFilterDates(){
    if(this.filterForm.controls.filterStartDate.value && this.filterForm.controls.filterEndDate.value){
        this.filterForm = this.fb.group({
            filterStartDate: this.filterForm.controls.filterStartDate.value,
            filterEndDate: this.filterForm.controls.filterEndDate.value,
        });
    }
}

  applyFileringMyOrders() {
    const filterValues = {
        option: "create",
        startDateFilter: dayjs(this.filterForm.controls.filterStartDate.value).format('YYYY-MM-DD'),
        endDateFilter:  dayjs(this.filterForm.controls.filterEndDate.value).format('YYYY-MM-DD'),
    }
    this.dialogRef.close(filterValues);
}

  cancel() {
    this.dialogRef.close({ "option": "cancel" });
  }

  sendSatelliteReportRequest() {

  }






  //   capturedFromDate;
  //   capturedToDate;

  // ngOnInit(): void {
  //   this.capturedFromDate = this.data.fromDate;
  //   this.capturedToDate = this.data.toDate;
  // }

  // dateFromChanged(event: MatDatepickerInputEvent<Date>) {
  //   this.capturedFromDate = event.value;
  // }

  // dateToChanged(event: MatDatepickerInputEvent<Date>) {
  //   this.capturedToDate = event.value;
  // }

  // cancel() {
  //   this.dialogRef.close({ "option": "cancel" });
  // }

  // sendSatelliteReportRequest() {

  // }

}







// export class DateRangeComponent implements OnInit {

//   constructor(@Inject(MAT_DIALOG_DATA) public data: any,
//     public dialogRef: MatDialogRef<FieldComponent>,
//     public dialog: MatDialog,
//     public _snackBar: MatSnackBar,
//     public translate: TranslateService) { }

//   capturedFromDate;
//   capturedToDate;

//   ngOnInit(): void {
//     this.capturedFromDate = this.data.fromDate;
//     this.capturedToDate = this.data.toDate;
//   }

//   dateFromChanged(event: MatDatepickerInputEvent<Date>) {
//     this.capturedFromDate = event.value;
//   }

//   dateToChanged(event: MatDatepickerInputEvent<Date>) {
//     this.capturedToDate = event.value;
//   }

//   applyDates() {
//     var newFromDate = moment(this.capturedFromDate);
//     var newToDate = moment(this.capturedToDate);
//     if (newFromDate == null || newToDate == null) {
//       this.dialogRef.close();
//     } else if (newFromDate < newToDate) {

//       this.dialogRef.close({ "fromDate": newFromDate, "toDate": newToDate });
//     } else {
//       this.openSnackBar(this.translate.instant("HISTORY-FILTER-DIALOG.DATE-ERROR"), this.translate.instant('SNACKBAR.DISMISS'));
//     }
//   }

//   cancel() {
//     this.dialogRef.close();
//   }

//   openSnackBar(message: string, action: string) {
//     this._snackBar.open(message, action, {
//       duration: 5000,
//     });
//   }

// }
